import { AxiosResponse } from "axios";
import { RestServiceConnection } from "../restServiceConnection";

const PRODUCTS_ENDPOINT = "/product";

export class ProductService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE PRODUCTOS
     * @EN GETS THE LIST OF PRODUCTS
     */
    // -------------------------------------------------------------------------------------------------------------
    listProducts = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PRODUCTS_ENDPOINT + "/list",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE EL LISTADO DE PRODUCTOS CON STOCK POR DEBAJO DEL MINIMO
     * @EN GETS THE LIST OF PRODUCTS WITH STOCK BELOW THE MINIMUM
     */
    // -------------------------------------------------------------------------------------------------------------
    listAlertStock = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PRODUCTS_ENDPOINT + "/list-alert-stock",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UN PRODUCTO POR SU ID
     * @EN GETS A PRODUCT BY ITS ID     
     */
    // -------------------------------------------------------------------------------------------------------------
    getProductById = async (productId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PRODUCTS_ENDPOINT + "/get",
            data: { id: productId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES TOGGLEA UN PRODUCTO
     * @EN TOGGLES A PRODUCT
     */
    // -------------------------------------------------------------------------------------------------------------
    toggleProductStatus = async (productId: string, status: boolean) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PRODUCTS_ENDPOINT + "/toggle",
            data: { id: productId, active: status },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UN PRODUCTO
     * @EN CREATES A PRODUCT
     */
    // -------------------------------------------------------------------------------------------------------------
    createProduct = async (product: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PRODUCTS_ENDPOINT + "/create",
            data: product,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA UN PRODUCTO
     * @EN EDITS A PRODUCT
     */
    // -------------------------------------------------------------------------------------------------------------
    editProduct = async (product: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PRODUCTS_ENDPOINT + "/edit",
            data: product,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UN PRODUCTO
     * @EN DELETES A PRODUCT
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteProduct = async (productId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PRODUCTS_ENDPOINT + "/delete",
            data: { id: productId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA VARIOS PRODUCTOS
     * @EN DELETES MULTIPLE PRODUCTS
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiProduct = async (productIds: string[]) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PRODUCTS_ENDPOINT + "/delete-multi",
            data: { 
                ids:productIds
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE PRODUCTOS PARA UN SELECT
     * @EN GETS THE LIST OF PRODUCTS FOR A SELECT   
     */
    // -------------------------------------------------------------------------------------------------------------
    listForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PRODUCTS_ENDPOINT + "/list-select",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}